import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import { Box, Tooltip } from "@mui/material";

import { UserAnalyticsService } from "@analytics/index";

interface IResourcesLinkProperties {
  color?: string;
  customClickHandler?: () => void;
  resourceLink?: string;
  workflow: string;
}

export default function ResourcesLink({
  color = "info.main",
  customClickHandler,
  resourceLink,
  workflow,
}: IResourcesLinkProperties) {
  const handleLinkClick = () => {
    if (customClickHandler) {
      customClickHandler();
    } else {
      window.open(resourceLink || "", "_blank");
    }
    UserAnalyticsService.trackResourceLink(resourceLink || "Custom Handler", workflow);
  };

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        gap: 0.5,
      }}
    >
      <Tooltip title="Watch short walkthrough video.">
        <VideocamRoundedIcon
          onClick={handleLinkClick}
          sx={{
            color,
            cursor: "pointer",
          }}
        />
      </Tooltip>
    </Box>
  );
}
